import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ResponseLogger, SirenResponse } from '@awp/http';
import { DataState } from './state/state';
import { SirenResponseAction } from './state/actions';

@Injectable()
export class ResponseStoreLogger implements ResponseLogger {

  constructor(private store: Store<DataState>) { }

  log(url: string, response: SirenResponse): void {
    this.store.dispatch(new SirenResponseAction({ id: response.rel[0], response }));
  }

}